import HeaderMedia from '~/components/header-modules/HeaderMedia.vue';
import HeaderText from '~/components/header-modules/HeaderText.vue';

export const HeaderModules = {
  HeaderMediumRecord: HeaderMedia,
  HeaderTextRecord: HeaderText,
};
